// ...existing code...
import React, { useEffect, useState } from "react";
import { addToCart } from "../services/CartServices";
import { useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import "./home.css";
import axios from "axios";
import toast, { Toaster } from "react-hot-toast";
import { motion } from "framer-motion";
import { FaStar } from "react-icons/fa";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { QuickViewModal } from "../components/QuickViewModal";

// 🖼️ IMPORT ALL YOUR EXISTING ASSETS
import heroVideo from "../assets/hero.mp4";
import adVideo from "../assets/DesktopNewYear.mp4";
import advideo2 from "../assets/MobileNewYear.mp4";
import adImage from "../assets/mobcombo1.mp4";
import bannerRight from "../assets/rightadbanner.mp4";
import bannerLeft from "../assets/adBanner.jpg";
import Natural from "../assets/natural.png";
import Handmade from "../assets/homemade.png";
import Cruelty from "../assets/curety.png";
import bodycare from "../assets/BodyCare.PNG";
import haircare from "../assets/HairCare.PNG";
import facecare from "../assets/FaceCare.PNG";
import gift from "../assets/GiftCare.png";
import midAdVideo from "../assets/midadvideo.mp4";
import specialOffer from "../assets/specialoffer.png";
import Eco from "../assets/eco.png";
import NewYear from "../assets/NewYearOffer.jpeg"
import NewYear1 from "../assets/NewYearOffer1.jpeg"

// 🎬 NEW SPECIAL BANNER ASSET
import newBanner from "../assets/firstOrder.mp4"; // add your own file here

// ✅ NEW (products combo landing)
const FIRST_ORDER_COMBO_URL = "/first-order-combo";

// 🖼️ Category images
const categoryImages = {
  bodycare,
  haircare,
  facecare,
  gifts: gift,
  specialoffer: specialOffer,
};

function normalizeCategoryName(name) {
  return name?.replace(/\s+/g, "").toLowerCase();
}

// 🛍️ FEATURED PRODUCTS
const FeaturedProducts = () => {
  const [products, setProducts] = useState([]);
  const [quickProduct, setQuickProduct] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const getFeaturedProducts = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/products`);
        setProducts(Array.isArray(res.data) ? res.data : res.data.products || []);
      } catch (err) {
        console.error("Error fetching featured products:", err);
      }
    };
    getFeaturedProducts();
  }, []);

  const openQuickView = (product) => {
    setQuickProduct(product);
    setIsModalOpen(true);
  };

  const handleAddToCart = async (product) => {
    const token = localStorage.getItem("token");
    if (!token) {
      toast.error("Please login to add items to cart.");
      navigate("/login");
      return;
    }
    try {
      await addToCart(product, 1, navigate);
      toast.success(`${product.name} added to cart 🛒`);
    } catch (err) {
      toast.error("Failed to add to cart.");
    }
  };

  return (
    <section className="featured-products">
      <Toaster position="top-center" reverseOrder={false} />
      <h2 className="section-title">🌿 Our Featured Products</h2>

      <Swiper
        style={{
          "--swiper-pagination-color": "var(--swiper-theme-color)",
          "--swiper-pagination-position": "relative",
          "--swiper-pagination-bottom": "1px",
        }}
        slidesPerView={1}
        spaceBetween={20}
        loop={true}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        breakpoints={{ 640: { slidesPerView: 2 }, 1024: { slidesPerView: 3 } }}
        pagination={{ clickable: true }}
        modules={[Autoplay, Pagination]}
        className="featured-swiper"
      >
        {products.map((product, index) => (
          <SwiperSlide key={product._id || product.id || index}>
            <motion.div
              className="product-card"
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
            >
              <img src={product.image} alt={product.name} className="product-img" />
              <h5 className="product-title">{product.name}</h5>
              <p className="price">
                ₹{product.discountedPrice ? product.discountedPrice : product.price}
                {product.discountPercent > 0 && (
                  <span style={{ color: "red", marginLeft: "8px", fontSize: "0.95em" }}>
                    <del>₹{product.price}</del> ({product.discountPercent}% OFF)
                  </span>
                )}
              </p>
              <div style={{ display: "flex", gap: "10px", justifyContent: "space-between" }}>
                <button 
                  className="add-cart-btn" 
                  style={{ flex: 1 }}
                  onClick={() => openQuickView(product)}
                >
                  Quick View
                </button>
                <button 
                  className="add-cart-btn" 
                  style={{ flex: 1 }}
                  onClick={() => handleAddToCart(product)}
                >
                  Add to Cart
                </button>
              </div>
            </motion.div>
          </SwiperSlide>
        ))}
      </Swiper>
      <QuickViewModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
        product={quickProduct} 
      />
    </section>
  );
};

// 💬 TESTIMONIALS
const testimonials = [
  { name: "Priya , Delhi", feedback: "These products have transformed my skincare routine! I feel confident and glowing every day.", rating: 5 },
  { name: "Abhijit , Guwahati", feedback: "Pure and effective! Love how soft and nourished my face feels now. Totally recommended!", rating: 4 },
  { name: "Sneha , Bangalore", feedback: "Love the natural fragrance and gentle touch on my skin. My go-to brand for self-care.", rating: 5 },
  { name: "Charu , Gurgaon", feedback: "The products are amazing! I've seen a noticeable difference in my skin's texture.", rating: 4 },
  { name: "Aditi , Noida", feedback: "The eco-friendly packaging is a big plus! I feel good about using products that care for the planet too.", rating: 5 },
];

const Testimonials = () => (
  <section className="testimonials" data-aos="fade-up">
    <motion.h2 className="section-title" initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
      💬 What Our Customers Say
    </motion.h2>
    <motion.div className="testimonial-swipe-container" whileTap={{ cursor: "grabbing" }}>
      {testimonials.map((t, i) => (
        <motion.div className="testimonial-card" key={i} initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: i * 0.2 }}>
          <div className="testimonial-header">
            <div>
              <h4>{t.name}</h4>
              <div className="stars">{[...Array(t.rating)].map((_, i) => <FaStar key={i} color="#f5b70a" />)}</div>
            </div>
          </div>
          <p>“{t.feedback}”</p>
        </motion.div>
      ))}
    </motion.div>
  </section>
);

// 🧴 CATEGORIES
const Categories = () => {
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/categories`)
      .then((res) => {
        const data = Array.isArray(res.data) ? res.data : res.data.categories || [];
        setCategories(data);
      })
      .catch((err) => console.error("Failed to fetch categories:", err));
  }, []);

  const handleCategoryClick = (slugOrId, name) => {
    if (normalizeCategoryName(name) === "gifts") navigate("/gifthampers");
    else navigate(`/category/${slugOrId}`);
  };

  return (
    <section className="categories-section" data-aos="fade-up">
      <motion.h2 className="section-title" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
        🧴 Explore Our Categories
      </motion.h2>

      <motion.div className="categories-grid" initial="hidden" whileInView="visible" variants={{ visible: { transition: { staggerChildren: 0.2 } } }}>
        {categories.map((cat, i) => (
          <motion.div
            className="category-card"
            key={cat._id || i}
            whileHover={{ scale: 1.05, rotate: 1 }}
            whileTap={{ scale: 0.95 }}
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4 }}
            onClick={() => handleCategoryClick(cat.slug || cat._id, cat.name)}
            style={{ cursor: "pointer" }}
          >
            <motion.img
              src={categoryImages[normalizeCategoryName(cat.name)] || cat.image}
              style={{ width: "300px", height: "460px", objectFit: "cover", borderRadius: "8px" }}
              alt={cat.name}
              whileHover={{ scale: 1.1 }}
              transition={{ type: "spring", stiffness: 100 }}
            />
            <motion.h5 whileInView={{ opacity: 1, y: 0 }} initial={{ opacity: 0, y: 10 }} transition={{ delay: 0.2 }}>
              {cat.name}
            </motion.h5>
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
};

// 🏠 HOME COMPONENT
const Home = () => {
  const [showNewBanner, setShowNewBanner] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  // 🧾 Check orders on mount and every 15s
  useEffect(() => {
    let intervalId;
    const checkUserOrders = async () => {
      const token = localStorage.getItem("token");
      // If not logged in → show banner for new users
      if (!token) {
        setShowNewBanner(true);
        return;
      }

      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/orders/user`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const orders = res.data?.orders || res.data || [];
        const hasSuccessful = orders.some((o) => {
          const s = ((o.status || o.state) || "").toString().toUpperCase();
          return s === "PAID" || s === "DELIVERED" || s === "SUCCESS";
        });

        setShowNewBanner(!hasSuccessful);
      } catch (err) {
        console.error("Error checking user orders:", err);
        // on error, be safe and show banner
        setShowNewBanner(true);
      }
    };

    checkUserOrders();
    intervalId = setInterval(checkUserOrders, 15000); // auto refresh every 15s

    return () => clearInterval(intervalId);
  }, []);

  // ✅ navigate to first order combo page
  const goToComboPage = () => {
    navigate(FIRST_ORDER_COMBO_URL);
  };

  const handleExploreClick = () => {
    const featuredSection = document.querySelector(".featured-products");
    if (featuredSection) {
      window.scrollTo({ top: featuredSection.offsetTop, behavior: "smooth" });
    }
  };

  return (
    <div className="home-page">
      {/* HERO SECTION */}
      <section className="hero-section" data-aos="fade-down">
        <div className="video-ad-container">
          {/* Mobile Top Ad */}
          <div className="ad-banner mobile-top" data-aos="fade-down">
            <video className="video-bg" autoPlay loop muted playsInline preload="auto" onClick={() => window.open("/gifthampers", "_self")}>
              <source src={advideo2} type="video/mp4" />
            </video>
          </div>

          {/* Main Video Wrapper */}
          <div className="main-video-wrapper">
            {/* Left Ad */}
            <div className="ad-banner ad-left" data-aos="fade-right">
              <video className="video-bg" autoPlay loop muted playsInline preload="auto" style={{objectFit:"fill", height:"100%"}} onClick={() => window.open("/gifthampers", "_self")}>
                <source  src={adVideo} type="video/mp4" />
              </video>
            </div>

            {/* Hero Video */}
            <div className="video-container">
              <video className="video-bg" autoPlay loop muted playsInline preload="auto">
                <source src={heroVideo} type="video/mp4" />
              </video>
              <div className="overlay">
                <div className="hero-content" data-aos="fade-up">
                  <h1>Discover the Power of Nature</h1>
                  <p>Handmade organic products tailored for your well-being.</p>
                </div>
              </div>
            </div>

            {/* Right Ad (image) */}
            <div className="ad-banner ad-right" data-aos="fade-left">
              <img
                src={NewYear}
                alt="New Year Offer"
                className="ad-image ad-right-image"
                style={{ objectFit: "fill", height: "100%", width: "100%", cursor: "pointer" }}
                loading="lazy"
                onClick={() => window.open("/new-year-combo-419", "_self")}
              />
            </div>
          </div>

          {/* Mobile Bottom Ad (image) */}
          <div className="ad-banner mobile-bottom" data-aos="fade-up">
            <img
              src={NewYear1}
              alt="New Year Offer"
              className="ad-image mobile-bottom-image"
              style={{ width: "100%", height:"100%", objectFit: "fill", cursor: "pointer" }}
              loading="lazy"
              onClick={() => window.open("/new-year-combo-419", "_self")}
            />
          </div>
        </div>
      </section>

      {/* 🎉 NEW USER BANNER SECTION */}
      {showNewBanner && (
        <motion.section
          className="new-user-banner"
          data-aos="fade-up"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          style={{
            backgroundColor: "#FFF8E7",
            padding: "40px 20px",
            borderRadius: "12px",
            textAlign: "center",
            margin: "40px 0",
            boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
          }}
        >
          <h2 style={{ fontSize: "2rem", marginBottom: "10px" }}>
            ✨ First Order Special — Pick ANY 3 for ₹333!
          </h2>

          <p style={{ fontSize: "1.1rem", color: "#444" }}>
            Choose <b>any 3 products</b> from our naturals collection — only for first-time shoppers 💚
          </p>

          <video
            src={newBanner}
            autoPlay
            loop
            muted
            playsInline
            onClick={goToComboPage}
            style={{
              width: "100%",
              maxWidth: "800px",
              borderRadius: "10px",
              marginTop: "20px",
              cursor: "pointer",
              objectFit: "cover",
              boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
            }}
          />

          <button
            onClick={goToComboPage}
            style={{
              marginTop: "25px",
              backgroundColor: "#3a7d44",
              color: "white",
              border: "none",
              padding: "12px 24px",
              borderRadius: "8px",
              cursor: "pointer",
              fontSize: "1rem",
              fontWeight: "600",
            }}
          >
            Grab Offer — Pick 3 Now 🎁
          </button>
        </motion.section>
      )}

      {/* FEATURED PRODUCTS */}
      <FeaturedProducts />

      {/* FEATURED CATEGORIES */}
      <Categories />

      {/* MID AD VIDEO */}
      <div className="mid-ad-section" data-aos="fade-up" style={{ backgroundColor: "#F0EAD6", borderRadius: "8px" }}>
        <video
          src={midAdVideo}
          autoPlay
          loop
          muted
          playsInline
          onClick={() => window.open("/category/special-offer", "_self")}
          className="mid-ad-video"
          style={{ borderRadius: "8px" }}
        />
      </div>

      {/* WHY CHOOSE US */}
      <section className="why-choose-us-section">
        <div className="wave-top">
          <svg viewBox="0 0 1440 100" preserveAspectRatio="none">
            <path d="M0,0 C480,100 960,0 1440,100 L1440,0 L0,0 Z" fill="#f2f6ff" />
          </svg>
        </div>

        <div className="why-choose-us" data-aos="fade-up">
          <h2>Why Choose Us?</h2>
          <p className="sub-text">
            Experience the magic of nature with our 100% organic, handmade wellness products. Thoughtfully crafted to heal, glow, and nourish your body and soul — all cruelty-free and eco-friendly.
          </p>

          <div className="choose-us-cards">
            <div className="choose-card" data-aos="fade-up" data-aos-delay="100">
              <img src={Natural} style={{ width: "200px", height: "200px", objectFit: "cover" }} alt="100% Natural" />
              <h3>100% Natural</h3>
              <p>Only the purest, chemical-free ingredients from nature’s lap.</p>
            </div>

            <div className="choose-card" data-aos="fade-up" data-aos-delay="200">
              <img src={Handmade} alt="Handmade with Love" />
              <h3>Handmade with Love</h3>
              <p>Crafted in small batches by passionate artisans using ancient traditions.</p>
            </div>

            <div className="choose-card" data-aos="fade-up" data-aos-delay="300">
              <img src={Cruelty} alt="Cruelty-Free" />
              <h3>Cruelty-Free</h3>
              <p>We never test on animals. Our love is for all living beings.</p>
            </div>

            <div className="choose-card" data-aos="fade-up" data-aos-delay="400">
              <img src={Eco} alt="Eco Friendly" />
              <h3>Eco Friendly</h3>
              <p>Committed to sustainable packaging and eco-conscious practices.</p>
            </div>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <Testimonials />
    </div>
  );
};

export default Home;
// ...existing code...
